import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Communications as SchemaCommunications } from '../schemas/Communications';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Returns every active communication eligible for the current store, its publication
state and the current time, excluding communications viewed by the current manager.
Ordered by priority DESC, then created_at DESC and id ASC; the client should preserve
this order when priorities are equal.

 * @tags Communications
 * @summary Get all eligible, unviewed communications for the current manager and store
 */
export const GetCommunicationsContentType = '' as const;
export type GetCommunicationsRequest = void;
export type GetCommunicationsResponses = LinkCommonErrorResponses & {
    /**
     * @description All eligible communications
     */
    '200': {
        'application/json': SchemaCommunications;
    };
};
export type GetCommunicationsResponseSuccess = GetCommunicationsResponses['200']['application/json'];
export type GetCommunicationsSearchParams = undefined;
export type GetCommunicationsPathParameters = undefined;
export const GetCommunicationsUrl = '/communications' as const;
export const GetCommunicationsMethod = 'GET' as const;
export const getGetCommunicationsUrl = (_params?: GetCommunicationsPathParameters) => GetCommunicationsUrl;
